import { createRoot } from 'react-dom/client';
import { matchPath } from 'react-router-dom';
import App from './App';
import EmailVerifiedPage from './resources/emailVerification/EmailVerifiedPage';
import { track, EVENTS } from './lib/analytics';
import * as authManager from './lib/authManager';
import './assets/fonts/fonts.css';

const container = document.getElementById('root');
const root = createRoot(container!);

const publicRoutes: Record<string, React.ReactElement> = {
  '/verify-email': <EmailVerifiedPage />,
};

const matchedRoute = Object.entries(publicRoutes).find(([pattern]) =>
  matchPath(pattern, window.location.pathname)
);

// Fora das rotas públicas, a sessão é retomada agora: a renovação viaja em paralelo
// com o boot do React e o checkAuth aguarda a mesma promise, então o usuário não
// percebe o request.
if (!matchedRoute) { void authManager.ensure().catch(() => { /* checkAuth decide */ }); }

root.render(matchedRoute ? matchedRoute[1] : <App />);

track(EVENTS.APP_STARTED);
